export default (element) => {
    const filterBtn = document.querySelector('[data-filter-btn]');
    const filterClear = document.querySelector('[data-filter-clear]');
    const filters = document.querySelector('[data-filters-block]');
    const filtersWrapper = document.querySelector('[data-filters-wrapper]');
    const collectionGrid = document.querySelector('[data-collection-grid]');
    const closeFiltersBtn = document.querySelector('[data-close-filters]')
    const filterText = document.querySelector('[data-filter-text]')

    //Open Filter functionality
    const toggleFilters = () => {
        if (collectionGrid.classList.contains('lg:filters-open')) {
            filterBtn.classList.replace('lg:min-w-[312px]', 'lg:min-w-[168px]');
            filterBtn.classList.remove('filters-open');

            filterClear.classList.replace('lg:ml-[318px]', 'lg:ml-0');

            collectionGrid.classList.replace('lg:grid-cols-4', 'lg:grid-cols-3');
            collectionGrid.classList.remove('lg:filters-open');

            filters.classList.add('hidden');
            filters.classList.remove('lg:block');
            filterText.innerText = window.innerWidth < 1024 ? 'Filter and sort' : 'Show Filters';


            document.body.style.overflow = ""
        }
        else {
            filterBtn.classList.replace('lg:min-w-[168px]', 'lg:min-w-[312px]');
            filterBtn.classList.add('filters-open');

            filterClear.classList.replace('lg:ml-0', 'lg:ml-[318px]');

            collectionGrid.classList.replace('lg:grid-cols-3', 'lg:grid-cols-4');
            collectionGrid.classList.add('lg:filters-open');

            filters.classList.remove('hidden')
            filters.classList.add('lg:block');
            filterText.innerText = 'Hide Filters'

            document.body.style.overflow = window.innerWidth < 1024 ? "hidden" : ''
        }
        updateFilterBtnWidth()
    }




    //accordion functionality
    const accordionBtns = document.querySelectorAll('[data-accordion-link]');

    function toggleAccordion(e) {
        e.preventDefault();
        const link = e.currentTarget;
        const parent = link.parentNode;
        const content = parent.querySelector('[data-accordion-content]')
        const plus = parent.querySelector('[data-accordion-plus]')
        const minus = parent.querySelector('[data-accordion-minus]')

        if (!content) return;
        if (link.classList.contains('open')) {
            link.classList.remove('open')
            content.classList.add('max-h-0', 'overflow-hidden')
            content.classList.remove('max-h-[1000px]')
            plus.classList.remove('hidden')
            minus.classList.add('hidden')
        }
        else {
            link.classList.add('open')
            content.classList.remove('h-0', 'overflow-hidden')
            content.classList.add('max-h-[1000px]')
            plus.classList.add('hidden')
            minus.classList.remove('hidden')
        }
    }


    window.addEventListener('resize', function (event) {
        updateFilterBtnWidth()
        if (window.innerWidth == 1024) {
            toggleFilters()
        }
    }, true);

    const updateFilterBtnWidth = () => {
        if (window.innerWidth > 1024 && filterBtn.classList.contains('filters-open')) {
            filterBtn.style.minWidth = `${filters.offsetWidth}px`
        } else {
            filterBtn.style.minWidth = ''
        }
    }
    const closeFiltersMobile = () => {
        if (window.innerWidth < 1024) {
            filterText.innerText = window.innerWidth < 1024 ? 'Filter and sort' : 'Show Filters';
        }
    }
    const init = () => {
        closeFiltersMobile();
        updateFilterBtnWidth()
        // eslint-disable-next-line no-new
        closeFiltersBtn.addEventListener('click', toggleFilters);
        filterBtn.addEventListener('click', toggleFilters);
        accordionBtns && accordionBtns.forEach(btn => btn.addEventListener('click', toggleAccordion));

        const waitForSSButton = setInterval(() => {
            const dataApplyBtn = element.querySelector('#searchspring-sidebar .button-primary');
            if (dataApplyBtn) {
                dataApplyBtn?.addEventListener('click', toggleFilters);
                clearInterval(waitForSSButton);
            }
        }, 100)
    };

    init();
};
